import React from 'react';
import { FDStack } from '@facet-wealth/design';
import Skeleton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Skeleton';
import {
  buildUseStyles,
  useTheme,
} from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';

const useStyles = buildUseStyles('ProposalProjectionSectionSkeleton', (theme) => ({
  skeleton: {
    borderRadius: theme.radius.md,
  },
  dot: {
    aspectRatio: 1,
    height: theme.spacing(2),
    width: theme.spacing(2),
  },
}));

const ProposalProjectionSectionSkeleton = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();
  return (
    <FDStack direction={'column'} alignItems={'center'} spacing={isMobile ? 1 : 2} width={'100%'}>
      <Skeleton className={classes.skeleton} variant={'rect'} width={250} height={65} />
      <Skeleton className={classes.skeleton} variant={'rect'} width={'100%'} height={120} />
      {Array.from({ length: 3 }, (_, index) => (
        <FDStack key={index} direction={'row'} alignItems={'center'} spacing={4} width={'100%'}>
          <Skeleton className={classes.skeleton} variant="rect" width={'100%'} height={260} />
        </FDStack>
      ))}
    </FDStack>
  );
};

ProposalProjectionSectionSkeleton.defaultProps = {};

ProposalProjectionSectionSkeleton.propTypes = {};

export { ProposalProjectionSectionSkeleton };
